module.exports = __webpack_public_path__ + "media/images/company/company_02_sub-4e2e5428795ba8c98cca6b50798c3f35.jpg";